<script>
import 'bulma/css/bulma.css'
import { hasAdminRole } from '@/api/Utilities.js'
import { getMyUserId } from '@/api/FirebaseUserWrapper.js'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
const analytics = getAnalytics(firebaseApp)
require('../../css/style.css')

export default {
  data () {
    return {
      userId: '',
      targetUrl: '',
      title: constant.DEFAULT_DOMAIN_TITLE
    }
  },
  async created () {
    this.userId = await getMyUserId()
    document.title = 'お問い合わせ | ' + this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', `お問い合わせ | ${this.title}`)
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.userId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'contact/Contact')
    }
  },
  beforeDestroy () {
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  methods: {
    clickGoogleForm () {
      const googleUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSfXz6XH2K5BZta004gGhxpxaDauC2pBq40QlB80rgahncCXbg/viewform?usp=pp_url'
      const userInfo = 'entry.485428648=' + this.userId
      // const pointedUrl = 'entry.141467706=' + this.pointedUrl
      this.targetUrl = googleUrl + '&' + userInfo
    }
  }
}
</script>
<style scoped>
.contact {
  text-align: center;
  max-width: 1024px;
  margin: auto;
  padding: 1.0rem;
}
</style>
<template>
  <div class="contact">
    <span class="text has-text-link has-text-weight-bold is-size-5">お問い合わせ</span>
    <div class="upper_body">
      <article class="media">
        <figure class="media-left">
          <p class="image is-96x96">
            <img src="./img/ad_wow.png">
          </p>
        </figure>
        <div class="media-content">
          <div class="field">
            <p class="control"><br>
              使い方の質問・追加機能の要望・バグ報告・退会は<br>
              お問合せフォームにお願いします<br>
            </p>
          </div>
        </div>
      </article>
    </div>
    <div class="lower_body">
      <div>
        <a  class="button is-link is-inverted is-outlined is-focused has-text-weight-bold" @click="clickGoogleForm ()" :href="targetUrl" target="_blank">
          <span class="icon">
            <i class="fa-brands fa-slack"></i>
          </span>
          <span>お問い合わせフォーム</span>
        </a>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/contact/Contact.vue